import offerSchemaName from './helpers/offerSchemaName'
import offerSchemaType from './helpers/offerSchemaType'
import offerSchemaLink from './helpers/offerSchemaLink'
import offerSchemaImage from './helpers/offerSchemaImage'

export default function display (buy, offer) {
    const url = offerSchemaLink(buy, offer)
    const bodyType = offer.data?.body_type || offer.data?.truck_body_type
    const price = offer.price
    const currency = price?.currency || 'PLN'
    return {
        '@context' : 'http://schema.org',
        '@type' : offerSchemaType(offer.type),
        'name' : offerSchemaName(buy, offer),
        'bodyType': bodyType,
        'fuelType': buy
            ? (offer.fuels || ['None']).join(' - ')
            : offer.fuel,
        'brand': {
          '@type': 'Brand',
          'name': buy
            ? (offer.makes || ['None']).join(' - ')
            : offer.make || 'None'
        },
        'model': buy
            ? (offer.models || ['None']).join(' - ')
            : offer.model,
        'color': offer.color,
        'numberOfDoors': offer.data?.doors,
        'itemCondition': offer._new
            ? 'new'
            : 'used',
        'url': url,
        'image' : offerSchemaImage(buy, offer),
        'offers' : [{
            '@context' : 'http://schema.org',
            '@type' : 'Offer',
            'availability': 'https://schema.org/InStock',
            'price': buy
                ? price?.od_price || price?.do_price || '0'
                : price?.price || '0',
            'priceCurrency': currency || 'PLN',
            'url': url
        }],
        'description': offer.description
    }
}